import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';

// Firestore 함수들 re-export
export {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  writeBatch,
  Timestamp,
  query,
  where,
  orderBy
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA5XMfUKDqJNhJuVeqS5xxwsv7ueBShTt0",
  authDomain: "luckytem-class-lab-00.firebaseapp.com",
  projectId: "luckytem-class-lab-00",
  storageBucket: "luckytem-class-lab-00.firebasestorage.app",
  messagingSenderId: "279471791057",
  appId: "1:279471791057:web:f9adc86bc9b4270a729ef0",
  measurementId: "G-PEYH3GBW4H"
};

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

// Firebase 서비스들 초기화
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// asia-northeast3(서울): checkStudentInfo, validateStudentAccess 등 Callable 리전과 일치
export const functions = getFunctions(app, 'asia-northeast3');

// Analytics는 지원되는 환경에서만 초기화
let analytics = null;
isSupported().then(yes => yes ? analytics = getAnalytics(app) : null);

export { analytics };

export default app; 